// extracted by mini-css-extract-plugin
export default {"container":"VB-z","contactUsLink":"WB-z"};